whenAppStarts(data);